import React from "react";
import styled from "@emotion/styled";
import { FeatureContainer, systemWidth } from "@kaltura/mediaspace-shared-styled";
import FaqSection from "../faq-section/FaqSection";
import ContactUs from "../contact-us/ContactUs";
import { HelpPageProps } from "./HelpPageProps";
import { Typography } from "@kaltura/ds-react-components";
import { useMediaQuery } from "@kaltura/mediaspace-shared-utils";
import { Theme } from "@mui/material/styles";

const StyledHelp = styled(FeatureContainer)(({ theme }) => ({
    "&": systemWidth({ theme }),
    marginTop: theme.spacing(3),
}));

const StyledWrapper = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        flexDirection: "row-reverse",
        justifyContent: "space-between",
    },
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up(theme.breakpoints.values.md)]: {
        marginBottom: theme.spacing(4),
    },
}));

const HelpPage = ({ sections, contactUsProps, pageTitle = "" }: HelpPageProps) => {
    const isLargeScreen = useMediaQuery<Theme>((theme) => theme.breakpoints.up(theme.breakpoints.values.md));

    return (
        <StyledHelp className="kms-ds-help-page">
            <StyledTitle component={"h1"} variant={isLargeScreen ? "h1" : "h2"}>
                {pageTitle}
            </StyledTitle>
            <StyledWrapper>
                {contactUsProps.contactUsEnabled && <ContactUs {...contactUsProps} />}
                <FaqSection sections={sections} />
            </StyledWrapper>
        </StyledHelp>
    );
};

export default HelpPage;
